import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import axios from "axios";

var Location = /*#__PURE__*/function () {
  function Location(_config, axios) {
    _classCallCheck(this, Location);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = _config;
  } // eslint-disable-next-line sonarjs/cognitive-complexity


  _createClass(Location, [{
    key: "searchByZip",
    value: function () {
      var _searchByZip = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(googleAPIKey, zip) {
        var response, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axios.get(this.config.postfix.SEARCH_BY_ADDRESS, {
                  params: {
                    address: zip,
                    key: googleAPIKey
                  }
                });

              case 2:
                response = _context.sent;
                data = response.data;

                if (!(data && data.status === "OK" && data.results.length > 0)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", data.results.map(function (record) {
                  var _record$geometry, _record$geometry$loca, _record$geometry2, _record$geometry2$loc;

                  var addressComponents = record.address_components;
                  var addressInfo = addressComponents.reduce(function (ret, addressComponent) {
                    if (addressComponent.types.indexOf("locality") > -1) {
                      ret.locality = addressComponent.short_name;
                    }

                    if (addressComponent.types.indexOf("postal_code") > -1) {
                      ret.postalCode = addressComponent.short_name;
                    }

                    if (addressComponent.types.indexOf("sublocality") > -1) {
                      ret.subLocality = addressComponent.short_name;
                    }

                    if (addressComponent.types.indexOf("administrative_area_level_1") > -1) {
                      ret.state = addressComponent.short_name;
                    }

                    if (addressComponent.types.indexOf("country") > -1) {
                      ret.country = addressComponent.short_name;
                    }

                    return ret;
                  }, {
                    addressTypes: [],
                    country: null,
                    formattedAddress: null,
                    latitude: null,
                    locality: null,
                    longitude: null,
                    placeId: null,
                    postalCode: null,
                    state: null,
                    subLocality: null
                  });
                  addressInfo.formattedAddress = record.formatted_address;
                  addressInfo.latitude = (_record$geometry = record.geometry) === null || _record$geometry === void 0 ? void 0 : (_record$geometry$loca = _record$geometry.location) === null || _record$geometry$loca === void 0 ? void 0 : _record$geometry$loca.lat;
                  addressInfo.longitude = (_record$geometry2 = record.geometry) === null || _record$geometry2 === void 0 ? void 0 : (_record$geometry2$loc = _record$geometry2.location) === null || _record$geometry2$loc === void 0 ? void 0 : _record$geometry2$loc.lng;
                  addressInfo.placeId = record.place_id;
                  addressInfo.addressTypes = record.types;
                  return addressInfo;
                }));

              case 8:
                return _context.abrupt("return", []);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function searchByZip(_x, _x2) {
        return _searchByZip.apply(this, arguments);
      }

      return searchByZip;
    }()
  }, {
    key: "getMapboxPlaceSuggestions",
    value: function () {
      var _getMapboxPlaceSuggestions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(mapboxAPIKey, address, brandCode, isLocationPermissionAllowed, isDeliveryFlow, proximity, isFromLocationSearch) {
        var _data$features, params, country, types, response, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                params = {};
                country = "us,ca"; // If proximity cannot be found, restrict search to USA only with the exception of OG Canada.

                if (!isLocationPermissionAllowed && brandCode !== "OG") {
                  country = "us";
                }

                if (address) {
                  _context2.next = 6;
                  break;
                }

                throw new Error("Search Text is Mandatory.");

              case 6:
                // creating diff mapBox Results.
                // using: -81.24257161, 28.65385106 in web.
                if (proximity && proximity.lat && proximity.lng) {
                  params["proximity"] = "".concat(proximity === null || proximity === void 0 ? void 0 : proximity.lng, ",").concat(proximity === null || proximity === void 0 ? void 0 : proximity.lat);
                }

                types = isFromLocationSearch ? "place,postcode,address,neighborhood,locality" : "place,postcode,address,region";
                _context2.next = 10;
                return this.axios.get(this.config.postfix.MAPBOX_SEARCH_AUTOCOMPLETE.replace("{address}", address.replace(" ", "%20")), {
                  params: _objectSpread(_objectSpread({}, params), {}, {
                    access_token: "pk.eyJ1IjoiZ3JhbWFzYW15IiwiYSI6ImNrZzhlNnE4YTBnaGgyeW8ycnNwc3Z0MjUifQ.TpPjJoGYawcq6kgIwPtmFg",
                    country: country,
                    types: isDeliveryFlow ? "address" : types
                  })
                });

              case 10:
                response = _context2.sent;
                data = response.data;

                if (!((data === null || data === void 0 ? void 0 : (_data$features = data.features) === null || _data$features === void 0 ? void 0 : _data$features.length) > 0)) {
                  _context2.next = 16;
                  break;
                }

                return _context2.abrupt("return", data);

              case 16:
                return _context2.abrupt("return", []);

              case 17:
                _context2.next = 22;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", []);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 19]]);
      }));

      function getMapboxPlaceSuggestions(_x3, _x4, _x5, _x6, _x7, _x8, _x9) {
        return _getMapboxPlaceSuggestions.apply(this, arguments);
      }

      return getMapboxPlaceSuggestions;
    }()
  }, {
    key: "getMapboxPlaceSuggestionsUsingText",
    value: function () {
      var _getMapboxPlaceSuggestionsUsingText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(mapboxAPIKey, address) {
        var _data$features2;

        var params, country, response, data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {};
                country = "US,CA,SV,KW,MX,AE,BR,PA,SA";

                if (address) {
                  _context3.next = 4;
                  break;
                }

                throw new Error("Search Text is Mandatory.");

              case 4:
                _context3.next = 6;
                return this.axios.get(this.config.postfix.MAPBOX_SEARCH_AUTOCOMPLETE.replace("{address}", address.replace(" ", "%20")), {
                  params: _objectSpread(_objectSpread({}, params), {}, {
                    access_token: "pk.eyJ1IjoiZ3JhbWFzYW15IiwiYSI6ImNrZzhlNnE4YTBnaGgyeW8ycnNwc3Z0MjUifQ.TpPjJoGYawcq6kgIwPtmFg",
                    country: country
                  })
                });

              case 6:
                response = _context3.sent;
                data = response.data;

                if (!((data === null || data === void 0 ? void 0 : (_data$features2 = data.features) === null || _data$features2 === void 0 ? void 0 : _data$features2.length) > 0)) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt("return", data);

              case 12:
                return _context3.abrupt("return", []);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getMapboxPlaceSuggestionsUsingText(_x10, _x11) {
        return _getMapboxPlaceSuggestionsUsingText.apply(this, arguments);
      }

      return getMapboxPlaceSuggestionsUsingText;
    }()
  }, {
    key: "getPlaceSuggestions",
    value: function () {
      var _getPlaceSuggestions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(googleAPIKey, searchText, location, radius, origin) {
        var params, response, data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {};

                if (!searchText) {
                  _context4.next = 5;
                  break;
                }

                params["input"] = searchText;
                _context4.next = 6;
                break;

              case 5:
                throw new Error("Search Text is Mandatory.");

              case 6:
                if (location) {
                  params["location"] = "".concat(location.lat, ",").concat(location.lng);
                }

                if (origin) {
                  params["origin"] = "".concat(origin.lat, ",").concat(origin.lng);
                }

                if (radius) {
                  params["radius"] = radius;
                }

                _context4.next = 11;
                return this.axios.get(this.config.postfix.MAPBOX_SEARCH_AUTOCOMPLETE, {
                  params: _objectSpread(_objectSpread({}, params), {}, {
                    key: googleAPIKey
                  })
                });

              case 11:
                response = _context4.sent;
                data = response.data;

                if (!(data && data.status === "OK" && data.results.length > 0)) {
                  _context4.next = 17;
                  break;
                }

                return _context4.abrupt("return", data.results);

              case 17:
                return _context4.abrupt("return", []);

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getPlaceSuggestions(_x12, _x13, _x14, _x15, _x16) {
        return _getPlaceSuggestions.apply(this, arguments);
      }

      return getPlaceSuggestions;
    }()
  }, {
    key: "getRestaurantDistance",
    value: function () {
      var _getRestaurantDistance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(longLat, curbs) {
        var _response$data, response;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return axios.get(this.config.postfix.MAPBOX_DISTANCE.replace("{coordinates}", longLat), {
                  params: {
                    approaches: curbs,
                    access_token: "pk.eyJ1IjoiZ3JhbWFzYW15IiwiYSI6ImNrZzhlNnE4YTBnaGgyeW8ycnNwc3Z0MjUifQ.TpPjJoGYawcq6kgIwPtmFg"
                  }
                });

              case 3:
                response = _context5.sent;
                return _context5.abrupt("return", (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.distances[0]);

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                console.log("err", _context5.t0);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function getRestaurantDistance(_x17, _x18) {
        return _getRestaurantDistance.apply(this, arguments);
      }

      return getRestaurantDistance;
    }()
  }]);

  return Location;
}();

export { Location as default };